const ContentElementType = {
  MARKDOWN: 'markdown',
  HTML: 'html',
  PLAIN_TEXT: 'plain_text',
  HREF: 'href',
} as const;

export default ContentElementType;
